import classes from "./Footer.module.css";
import AiNLogo from "../../Assets/Images/AiNLogo.svg";

const Footer = () => {
  return (
    <div className={classes.container}>
      <div className={classes.footerUpper}>
        <img src={AiNLogo} alt="AIESEC In Nigeria" />

        <div>
          <p>Our Socials</p>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="38"
              height="30"
              viewBox="0 0 38 30"
              fill="none"
              onClick={() => {
                window.open("https://www.youtube.com/c/AiesecnigeriaOrg");
              }}
            >
              <path
                d="M19.4473 0.333252C20.4263 0.338752 22.8756 0.362585 25.479 0.467085L26.403 0.507418C29.0228 0.630252 31.6408 0.842918 32.9406 1.20409C34.6731 1.69175 36.0335 3.11075 36.4936 4.91109C37.227 7.77109 37.3186 13.3481 37.3296 14.6993L37.3315 14.9779V15.2969C37.3186 16.6481 37.227 22.2269 36.4936 25.0851C36.028 26.8909 34.6658 28.3118 32.9406 28.7921C31.6408 29.1533 29.0228 29.3659 26.403 29.4888L25.479 29.5309C22.8756 29.6336 20.4263 29.6593 19.4473 29.6629L19.0165 29.6648H18.549C16.4773 29.6519 7.81296 29.5584 5.05563 28.7921C3.32496 28.3044 1.96279 26.8854 1.50263 25.0851C0.769293 22.2251 0.677626 16.6481 0.666626 15.2969V14.6993C0.677626 13.3481 0.769293 7.76925 1.50263 4.91109C1.96829 3.10525 3.33046 1.68442 5.05746 1.20592C7.81296 0.437752 16.4791 0.344252 18.5508 0.333252H19.4473ZM15.3315 8.58325V21.4166L26.3315 14.9999L15.3315 8.58325Z"
                fill="#131112"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="34"
              viewBox="0 0 19 34"
              fill="none"
              onClick={() => {
                window.open(
                  "https://web.facebook.com/AIESECinNigeria?_rdc=1&_rdr"
                );
              }}
            >
              <path
                d="M12.3333 19.4999H16.5L18.1666 12.8333H12.3333V9.49992C12.3333 7.78325 12.3333 6.16658 15.6666 6.16658H18.1666V0.566585C17.6233 0.494919 15.5716 0.333252 13.405 0.333252C8.87996 0.333252 5.66663 3.09492 5.66663 8.16658V12.8333H0.666626V19.4999H5.66663V33.6666H12.3333V19.4999Z"
                fill="#131112"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="34"
              height="30"
              viewBox="0 0 34 30"
              fill="none"
              onClick={() => {
                window.open("https://twitter.com/AIESECinNigeria?s=20");
              }}
            >
              <path
                d="M11 0H0.5L12.89 16.521L1.175 30H5.15L14.732 18.9765L23 30H33.5L20.588 12.783L31.7 0H27.725L18.746 10.329L11 0ZM24.5 27L6.5 3H9.5L27.5 27H24.5Z"
                fill="#131112"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="33"
              height="31"
              viewBox="0 0 33 31"
              fill="none"
              onClick={() => {
                window.open(
                  "https://www.linkedin.com/company/aiesec-in-nigeria"
                );
              }}
            >
              <path
                d="M7.56669 4.33329C7.56625 5.21735 7.21464 6.06502 6.5892 6.68983C5.96377 7.31463 5.11575 7.6654 4.23169 7.66496C3.34764 7.66452 2.49997 7.3129 1.87516 6.68747C1.25035 6.06204 0.899583 5.21401 0.900025 4.32996C0.900467 3.4459 1.25208 2.59823 1.87751 1.97342C2.50295 1.34861 3.35097 0.997849 4.23502 0.998291C5.11908 0.998733 5.96675 1.35035 6.59156 1.97578C7.21637 2.60121 7.56713 3.44924 7.56669 4.33329ZM7.66669 10.1333H1.00002V31H7.66669V10.1333ZM18.2 10.1333H11.5667V31H18.1334V20.05C18.1334 13.95 26.0834 13.3833 26.0834 20.05V31H32.6667V17.7833C32.6667 7.49996 20.9 7.88329 18.1334 12.9333L18.2 10.1333Z"
                fill="#131112"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              onClick={() => {
                window.open("https://www.instagram.com/aiesecinnigeria/");
              }}
            >
              <path
                d="M17.0016 11.9999C15.6755 11.9999 14.4038 12.5267 13.4661 13.4644C12.5284 14.4021 12.0016 15.6738 12.0016 16.9999C12.0016 18.326 12.5284 19.5978 13.4661 20.5355C14.4038 21.4731 15.6755 21.9999 17.0016 21.9999C18.3277 21.9999 19.5995 21.4731 20.5372 20.5355C21.4748 19.5978 22.0016 18.326 22.0016 16.9999C22.0016 15.6738 21.4748 14.4021 20.5372 13.4644C19.5995 12.5267 18.3277 11.9999 17.0016 11.9999ZM17.0016 8.66658C19.2118 8.66658 21.3314 9.54456 22.8942 11.1074C24.457 12.6702 25.335 14.7898 25.335 16.9999C25.335 19.2101 24.457 21.3297 22.8942 22.8925C21.3314 24.4553 19.2118 25.3333 17.0016 25.3333C14.7915 25.3333 12.6719 24.4553 11.1091 22.8925C9.54627 21.3297 8.66829 19.2101 8.66829 16.9999C8.66829 14.7898 9.54627 12.6702 11.1091 11.1074C12.6719 9.54456 14.7915 8.66658 17.0016 8.66658ZM27.835 8.24992C27.835 8.80245 27.6155 9.33236 27.2248 9.72306C26.8341 10.1138 26.3042 10.3333 25.7516 10.3333C25.1991 10.3333 24.6692 10.1138 24.2785 9.72306C23.8878 9.33236 23.6683 8.80245 23.6683 8.24992C23.6683 7.69738 23.8878 7.16748 24.2785 6.77678C24.6692 6.38608 25.1991 6.16658 25.7516 6.16658C26.3042 6.16658 26.8341 6.38608 27.2248 6.77678C27.6155 7.16748 27.835 7.69738 27.835 8.24992ZM17.0016 3.66659C12.8783 3.66659 12.205 3.67825 10.2866 3.76325C8.97996 3.82492 8.10329 3.99992 7.28996 4.31659C6.60932 4.56648 5.99398 4.96702 5.48996 5.48825C4.96831 5.99225 4.56722 6.60756 4.31663 7.28825C3.99996 8.10492 3.82496 8.97992 3.76496 10.2849C3.67829 12.1249 3.66663 12.7683 3.66663 16.9999C3.66663 21.1249 3.67829 21.7966 3.76329 23.7149C3.82496 25.0199 3.99996 25.8983 4.31496 26.7099C4.59829 27.4349 4.93163 27.9566 5.48496 28.5099C6.04663 29.0699 6.56829 29.4049 7.28496 29.6816C8.10829 29.9999 8.98496 30.1766 10.285 30.2366C12.125 30.3232 12.7683 30.3333 17 30.3333C21.125 30.3333 21.7966 30.3216 23.715 30.2366C25.0183 30.1749 25.895 29.9999 26.71 29.6849C27.39 29.4338 28.0051 29.0334 28.51 28.5133C29.0716 27.9533 29.4066 27.4316 29.6833 26.7132C30 25.8932 30.1766 25.0166 30.2366 23.7133C30.3233 21.8749 30.3333 21.2299 30.3333 16.9999C30.3333 12.8766 30.3216 12.2033 30.2366 10.2849C30.175 8.98159 29.9983 8.10158 29.6833 7.28825C29.4321 6.60828 29.0317 5.99322 28.5116 5.48825C28.0079 4.96633 27.3925 4.5652 26.7116 4.31492C25.895 3.99825 25.0183 3.82325 23.715 3.76325C21.8766 3.67659 21.235 3.66659 17.0016 3.66659ZM17.0016 0.333252C21.53 0.333252 22.095 0.349919 23.8733 0.433252C25.6466 0.516585 26.8566 0.794919 27.9183 1.20825C29.0183 1.63159 29.945 2.20492 30.8716 3.12992C31.7191 3.96308 32.3749 4.9709 32.7933 6.08325C33.205 7.14492 33.485 8.35492 33.5683 10.1299C33.6466 11.9066 33.6683 12.4716 33.6683 16.9999C33.6683 21.5283 33.6516 22.0933 33.5683 23.8699C33.485 25.6449 33.205 26.8533 32.7933 27.9166C32.376 29.0295 31.7201 30.0376 30.8716 30.8699C30.0382 31.7171 29.0305 32.3728 27.9183 32.7916C26.8566 33.2033 25.6466 33.4833 23.8733 33.5666C22.095 33.6449 21.53 33.6666 17.0016 33.6666C12.4733 33.6666 11.9083 33.6499 10.13 33.5666C8.35663 33.4833 7.14829 33.2033 6.08496 32.7916C4.97217 32.374 3.96417 31.7182 3.13163 30.8699C2.28401 30.0369 1.62823 29.029 1.20996 27.9166C0.796628 26.8549 0.518295 25.6449 0.434961 23.8699C0.354961 22.0933 0.334961 21.5283 0.334961 16.9999C0.334961 12.4716 0.351628 11.9066 0.434961 10.1299C0.518295 8.35325 0.796628 7.14658 1.20996 6.08325C1.62702 4.97022 2.28297 3.96212 3.13163 3.12992C3.96441 2.28197 4.97234 1.62613 6.08496 1.20825C7.14663 0.794919 8.35496 0.516585 10.13 0.433252C11.9083 0.354919 12.4733 0.333252 17.0016 0.333252Z"
                fill="#131112"
              />
            </svg>
          </div>
        </div>
        <div>
          <p>Our Address</p>
          <p>
            6th floor Co-Creation Hub (CCHUb) 294, Herbert Macaulay Way, Yaba,
            Lagos, Nigeria.
          </p>
        </div>
      </div>
      <div className={classes.footerLower}>IYD 2023</div>
    </div>
  );
};

export default Footer;
